import Checkbox from "@/components/checkbox.vue";
import moment from "moment";
import { formatAmount } from "../lib/formatAmount";
import { truncateString } from "../lib/truncateString";
import { parseJson } from "../lib/parseJson";
import { maskString } from "../lib/maskString";
import { capitalizeFirstLetter } from "../lib/capitalize";
import { getBank } from "../lib/utils";
import startCase from "lodash/startCase";

export default {
  // Fetch auth token
  getApiAuth: (state) => {
    return state.requestKey;
  },
  getUserDetails: (state) => {
    return state.userDetails;
  },
  getBankName: (state) => (getBankCode = null) => {
    if (!getBankCode) return state.bankList;

    const bank = state.bankList.find((element) => {
      return element.code == getBankCode || element.cbn_code === getBankCode;
    });
    return bank ? bank.name || bank.bank || "" : "";
  },
  getSettlements: (state) => {
    if (state.settlements.page_info) {
      return {
        loading: state.settlements.loading,
        pageInfo: state.settlements.page_info,
        settlements: state.settlements.settlements.map((settlement) => ({
          id: settlement.settlement_reference,
          STATUS: settlement.settlement_status
            ? settlement.settlement_status.toLowerCase()
            : "",
          REFERENCE: settlement.settlement_reference,
          "INITIATION DATE": `${moment(settlement.created_at).format(
            "hh:mm a"
          )} - ${moment(settlement.created_at).format("ll")}`,
          "SOURCE ACCOUNT":
            settlement.collection_bank_short_name.toUpperCase() +
            " - " +
            settlement.collection_nuban,
          "DESTINATION ACCOUNT":
            settlement.settlement_bank_short_name.toUpperCase() +
            " - " +
            settlement.settlement_nuban,
          MERCHANT: settlement.merchant_name,
          AMOUNT: `₦ ${formatAmount(settlement.amount)}`,
        })),
      };
    } else {
      return {
        loading: state.settlements.loading,
        pageInfo: {},
        settlements: [],
      };
    }
  },
  getFullSettlements: (state) => {
    if (state.settlements.settlements) {
      return state.settlements.settlements;
    }
  },
  getBankNames: (state) => {
    return state.bankNames;
  },
  getBankList: (state) => {
    return state.bankList;
  },
  getSettlementTransactions: (state) => {
    if (!state.settlementTransactions.loading) {
      return {
        loading: false,
        page_info: state.settlementTransactions.page_info,
        settlementTransactions: state.settlementTransactions
          .unsetlled_transactions.length
          ? state.settlementTransactions.unsetlled_transactions.map(
              (settlementTransaction) => ({
                checkbox: Checkbox,
                id: settlementTransaction.id,
                REFERENCE: settlementTransaction.transaction_reference,
                "MERCHANT ID": settlementTransaction.merchant_id,
                "MERCHANT NAME": settlementTransaction.business_name,
                "PAYMENT DATE": `${moment(
                  settlementTransaction.transaction_date
                ).format("ll")}, ${moment(
                  settlementTransaction.transaction_date
                ).format("hh:mm a")} `,
                "PAYER NAME": settlementTransaction.payer_account_name,
                "PAYER ACCOUNT":
                  settlementTransaction.payer_bank +
                  " - " +
                  settlementTransaction.payer_account_number,
                AMOUNT: `₦ ${settlementTransaction.amount}`,
              })
            )
          : [],
      };
    } else {
      return {
        loading: true,
        settlementTransactions: [],
      };
    }
  },
  getSettlementBatchDetails: ({ settlementBatchDetail, bankList }) => {
    if (settlementBatchDetail.tableLoading) return { tableLoading: true };
    return {
      ...settlementBatchDetail,
      status: String(
        settlementBatchDetail.settlement_retry_status ||
          settlementBatchDetail.settlement_status ||
          ""
      ).toLowerCase(),
      amountPayable: `₦ ${formatAmount(settlementBatchDetail.amount_payable)}`,
      amount: `₦ ${formatAmount(settlementBatchDetail.amount)}`,
      date: moment(
        settlementBatchDetail.settlement_date || settlementBatchDetail.updatedAt
      ).format("llll"),
      updatedAt: moment(settlementBatchDetail.updatedAt).format("llll"),
      createdAt: moment(settlementBatchDetail.createdAt).format("llll"),

      sourceBank: settlementBatchDetail.collection_bank,
      destinationBank: settlementBatchDetail.settlement_nuban,
      bank: getBank(bankList, settlementBatchDetail.settlement_bank_code).bank,
    };
  },
  getSettlementDetails: ({ settlementDetail }) => {
    if (!settlementDetail.loading) {
      return {
        ...settlementDetail,
        id: settlementDetail.id,
        loading: settlementDetail.loading,
        pageInfo: settlementDetail.page_info,
        reference: settlementDetail.id,
        merchantName: settlementDetail.merchant_name,
        amount: `₦ ${formatAmount(settlementDetail.amount)}`,
        status: (settlementDetail.status || "").toLowerCase(),
        sourceBank: settlementDetail.collection_bank,
        destinationBank: settlementDetail.settlement_bank,
        tableLoading: settlementDetail.tableLoading,
        amountPayable: `₦ ${formatAmount(settlementDetail.amount_payable)}`,
        totalFee: `₦ ${formatAmount(
          settlementDetail.bank_fee + settlementDetail.woven_fee
        )}`,
        downloadableTransactions: (settlementDetail.transactions || []).length
          ? settlementDetail.transactions.map((transaction) => ({
              id: transaction.id,
              Transaction_Reference: transaction.transaction_reference,
              Mandate: transaction.mandate,
              Transaction_Date: ` ${moment(transaction.transaction_date).format(
                "lll"
              )}`,
              Source_Name: transaction.source_name,
              Source_Bank: transaction.source_bank,
              Customer_Name: transaction.customer_name,
              "Receiving_(Settlement)_Account_No":
                transaction.destination_nuban,
              Receiving_Bank: transaction.destination_bank,
              Amount: `${formatAmount(transaction.amount)}`,
              Fee: `${formatAmount(transaction.fee)}`,
            }))
          : [],
        transactions: (settlementDetail.transactions || []).length
          ? settlementDetail.transactions.map((transaction) => ({
              id: transaction.transaction_reference || transaction.id,
              // "MERCHANT ID": transaction.merchant_id,
              REFERENCE: transaction.transaction_reference || transaction.id,
              //     {
              //   isHtml: ` <a title="View Transaction Details" href="/dashboard/transactions/${transaction.transaction_reference || transaction.id}" style="text-decoration: none; color: inherit">${transaction.transaction_reference}</a>`
              // },
              "PAYMENT DATE": ` ${moment(transaction.transaction_date).format(
                "ll"
              )} , ${moment(transaction.transaction_date).format("hh:mm a")}`,
              "PAYER NAME": transaction.payer_name,
              "PAYER MANDATE": transaction.mandate,
              //     {
              //   isHtml: ` <a title="View ${transaction.payer_name} Details" href="/dashboard/customers/${transaction.mandate}" style="text-decoration: none; color: inherit">${transaction.payer_name}</a>`
              // },
              "PAYER ACCOUNT":
                transaction.destination_nuban +
                " - " +
                truncateString(transaction.destination_bank, 15),
              AMOUNT: `₦ ${formatAmount(transaction.amount)}`,
            }))
          : [],
      };
    } else {
      return {
        loading: true,
      };
    }
  },

  getFullSettlementTransactions: (state) => {
    if (state.settlementTransactions.transactions) {
      return state.settlementTransactions.transactions;
    }
  },

  getSettlementTransactionDetailChunk: ({
    settlementTransactions,
    bankNames,
  }) => {
    const { unsetlled_transactions } = settlementTransactions;

    if (!settlementTransactions.loading) {
      const meta = unsetlled_transactions[0].meta;

      return {
        loading: false,
        details: unsetlled_transactions.length
          ? [
              {
                Reference: unsetlled_transactions[0].transaction_reference,
                "Transaction Date": moment(
                  unsetlled_transactions[0].created_at
                ).format("LL"),
              },
              {
                "Payer Name": unsetlled_transactions[0].payer_account_name,
                Amount: unsetlled_transactions[0].amount,
              },
              {
                "Payer Account Number":
                  unsetlled_transactions[0].payer_account_number,
                "Payer Bank": bankNames[
                  unsetlled_transactions[0].payer_bank_code
                ]
                  ? bankNames[unsetlled_transactions[0].payer_bank_code].name
                  : "N/A",
              },
              {
                "Source (Collection) Account No.":
                  unsetlled_transactions[0].source_bank,
                "Source Bank": unsetlled_transactions[0].source_bank,
              },
              {
                "Recieving (Settlement) Account No.":
                  unsetlled_transactions[0].receiving_account_number,
                "Receiving Bank": meta
                  ? parseJson(meta).bank_name || "N/A"
                  : "",
              },
            ]
          : [],
        subDetails: unsetlled_transactions.length
          ? {
              title: "Merchant",
              details: {
                "Merchant ID": unsetlled_transactions[0].merchant_id,
                "Merchant Name": unsetlled_transactions[0].customer_name,
              },
            }
          : {},
      };
    } else {
      return {
        loading: true,
        details: [],
        subDetails: {
          title: "",
          details: {},
        },
      };
    }
  },
  getRowSelected: (state) => {
    return state.rowSelected;
  },
  getRetriesRowSelected: (state) => {
    return state.retriesRowSelected;
  },
  getTranchesRowSelected: (state) => {
    return state.tranchesRowSelected;
  },

  getPayoutDashboard: (state) => {
    if (!state.payoutDashboard.loading) {
      const { page_info, payout_summaries } = state.payoutDashboard;

      const payOutDashboard = payout_summaries.length
        ? payout_summaries.map(
            ({ merchant, balance, total_payout, merchant_id }) => ({
              id: merchant_id,
              MERCHANT: merchant,
              BALANCE: `₦ ${formatAmount(balance)}`,
              "TOTAL PAYOUT": `₦ ${formatAmount(total_payout)}`,
              "": "",
            })
          )
        : [];

      return {
        payOutDashboard,
        pageInfo: page_info,
      };
    }

    return {
      payOutDashboard: [],
      loading: true,
    };
  },
  getPayoutDetails: (state) => {
    if (!state.payOutDetails.loading) {
      const { data, type } = state.payOutDetails;

      let contents;

      if (type === "payouts") {
        contents = data.payout_transactions.length
          ? data.payout_transactions.map(
              ({
                source_bank_code,
                beneficiary_nuban,
                amount,
                transaction_date,
                status,
                bank_code,
                source_nuban,
                merchant_name,
                merchant_id,
                payout_reference,
              }) => ({
                payout_reference,
                id: merchant_id,
                STATUS:
                  status.toUpperCase() === "ACTIVE" ||
                  status.toUpperCase() === "SUCCESSFUL"
                    ? "successful"
                    : status === "INQ"
                    ? "pending"
                    : "failed",
                MERCHANT: merchant_name || "",
                "SOURCE VNUBAN": `${
                  state.bankNames[source_bank_code]
                    ? state.bankNames[source_bank_code].name.toUpperCase()
                    : "N/A"
                } - ${source_nuban || "N/A"}`,
                BENEFICIARY: `${
                  state.bankNames[bank_code]
                    ? state.bankNames[bank_code].name.toUpperCase()
                    : "N/A"
                } - ${beneficiary_nuban}`,
                AMOUNT: `₦ ${formatAmount(amount)}`,
                DATE: `${moment(transaction_date).format("ll")}`,
                "TRANSACTION TYPE": "Payout",
              })
            )
          : [];
      } else {
        contents = data.transaction_history.length
          ? data.transaction_history.map(
              ({
                source_nuban,
                status,
                amount,
                transaction_date,
                transaction_reference,
              }) => ({
                STATUS: status
                  ? status.toUpperCase() === "ACTIVE" ||
                    status.toUpperCase() === "SUCCESSFUL"
                    ? "successful"
                    : status === "INQ"
                    ? "pending"
                    : "failed"
                  : "Available",
                SOURCE: source_nuban,
                AMOUNT: `₦ ${formatAmount(amount)}`,
                "TRANSACTION DATE": `${moment(transaction_date).format("ll")}`,
                "TRANSACTION REFERENCE": transaction_reference,
                "TRANSACTION TYPE": "Funding",
              })
            )
          : [];
      }

      return {
        contents,
        pageInfo: data.page_info,
        type,
      };
    }

    return {
      loading: true,
      contents: [],
    };
  },
  getSinglePayoutDetails: (state) => {
    if (!state.singlePayoutDetails.loading) {
      const {
        payout_reference,
        beneficiary_account_name,
        status,
        beneficiary_nuban,
        bank_code,
        id,
        amount,
        meta_data,
        createdAt,
        transaction_date,
        fee,
      } = state.singlePayoutDetails;

      const parsedMeta = parseJson(meta_data);

      return {
        ...state.singlePayoutDetails,
        bankName: state.bankNames[bank_code]
          ? state.bankNames[bank_code].name
          : "N/A",
        accountNumber: maskString(beneficiary_nuban, 5),
        amount: formatAmount(amount),
        fee: fee ? `${formatAmount(fee)}` : 0.0,
        email: parsedMeta ? parsedMeta.beneficiary_email : "",
        initiationDate: moment(createdAt).format("llll"),
        transactionDate: moment(transaction_date).format("llll"),
      };
    }

    return {
      loading: true,
    };
  },
  getRoutingRules: (state) => {
    if (!state.routingRules.loading) {
      return {
        loading: false,
        rules: state.routingRules.rules.length
          ? state.routingRules.rules.map(
              ({
                priority,
                bank_code,
                bank,
                bank_prefix,
                percent_of_merchants,
                minimum_incoming,
                maximum_incoming,
                id,
              }) => ({
                id: `${id}`,
                priority: Number(priority),
                bank,
                prefix: `${bank_prefix}******`,
                preExisting: `${percent_of_merchants}`,
                incomingMin: Number(minimum_incoming),
                incomingMax:
                  Number(maximum_incoming) >= 0
                    ? Number(maximum_incoming)
                    : "infinity",
                bankCode: bank_code,
              })
            )
          : [],
      };
    } else {
      return {
        loading: true,
        rules: [],
      };
    }
  },
  getRawRoutingRules: (state) => {
    if (!state.routingRules.loading) {
      return {
        loading: false,
        rules: state.routingRules.rules,
      };
    } else {
      return {
        loading: true,
        rules: [],
      };
    }
  },
  getGlobalRoutingRules: (state) => {
    if (!state.routingRules.loading) {
      return {
        loading: false,
        rules: state.routingRules.rules.length
          ? state.routingRules.rules.map(
              ({
                priority,
                bank,
                bank_prefix,
                percent_of_merchants,
                minimum_incoming,
                maximum_incoming,
              }) => ({
                PRIORITY: priority,
                BANK: `${bank_prefix}****** - ${bank}`,
                "PREEXISTING MERCHANTS": `${percent_of_merchants}`,
                "INCOMING MERCHANTS": `${minimum_incoming} - ${maximum_incoming ||
                  "infinity"}`,
              })
            )
          : [],
      };
    } else {
      return {
        loading: true,
        rules: [],
      };
    }
  },
  getBankListKeyAndValuePair: (state) => {
    if (state.bankList) {
      return Object.values(state.bankList).map(
        ({ bank, code, rule_applied }) => ({
          rule_applied,
          id: code,
          value: bank,
        })
      );
    }
    return state.bankList;
  },
  getMerchantRoutingRules: (state) => {
    if (!state.merchantRoutingRules.loading) {
      return {
        isSettingMerchantSpecificRule:
          state.merchantRoutingRules.isSettingMerchantSpecificRule,
        loading: false,
        rules: state.merchantRoutingRules.merchant_routing_rules.length
          ? state.merchantRoutingRules.merchant_routing_rules.map(
              ({ bank, rule_type, status }) => ({
                BANK: bank,
                "RULE TYPE": rule_type,
                "STATUS-COVER": status,
              })
            )
          : [],
      };
    }

    return {
      isSettingMerchantSpecificRule:
        state.merchantRoutingRules.isSettingMerchantSpecificRule,
      loading: true,
      rules: [],
    };
  },
  getMerchantSpecificRoutingRules: (state) => {
    if (!state.merchantSpecificRules.loading) {
      return {
        loading: false,
        rules: state.merchantSpecificRules.merchant_routing_rules.length
          ? state.merchantSpecificRules.merchant_routing_rules.map(
              ({ bank, rule_type, status }) => ({
                BANK: bank,
                "RULE TYPE": rule_type,
                "STATUS-COVER": status,
              })
            )
          : [],
      };
    }

    return {
      loading: true,
      rules: [],
    };
  },
  getDefaultCollectionAccount: (state) => {
    return state.defaultCollectionAccount;
  },
  getFees: (state) => {
    if (!state.fees.loading) {
      const rule = {
        EQ: "Equals",
        LT: "Less than",
        GT: "Greater than",
        LTE: "Less than or equal to",
        GTE: "Greater than or equal to",
        CNT: "Contains",
        NCNT: "Does not contain",
      };

      const feeProperties = {
        total_merchant_amount: "Total Merchant Amount",
        total_merchant_volume: "Total Merchant Volume",
        total_nuban_amount: "Total Nuban Amount",
        total_nuban_volume: "Total Nuban Volume",
        amount: "Amount",
        hour: "Hour",
        nuban: "Nuban",
      };

      const type = {
        "vnuban payment": "vNUBAN Payment",
        "merchant vnuban funding": "Merchant vNUBAN Funding",
        "customer vnuban funding": "Customer vNUBAN Funding",
        payout: "Payout Transaction",
        "direct debit": "Direct Debit",
      };

      const fees = state.fees.fees.map(
        ({ id, fee_meta, transaction_type, bank_short_name, merchant_id }) => {
          const meta = JSON.parse(fee_meta);

          return {
            id,
            PRIORITY: (meta.fee_rules && meta.fee_rules[0].index) || "",
            "TRANSACTION TYPE": startCase(transaction_type),
            WOVEN: `${
              meta.fee_rules && meta.fee_rules[0].fee_type === "FLAT"
                ? "Flat"
                : "Percentage"
            } Fee - ${
              meta.fee_rules && meta.fee_rules[0].fee
                ? meta.fee_rules[0].fee
                : "0"
            } || Min ${meta.min_fees || "0"} - Max ${meta.max_fees || "0"}`,
            BANK: `${
              bank_short_name ? bank_short_name.toUpperCase() : ""
            } - ${(meta.fee_split_rules && meta.fee_split_rules.bank.value) ||
              "0"} ${
              meta.fee_split_rules && meta.fee_split_rules.bank.type == "FLAT"
                ? ""
                : meta.fee_split_rules &&
                  meta.fee_split_rules.bank.type == "PERCENT"
                ? "%"
                : ""
            }`,
            "FEE PROPERTY": `${(meta.fee_rules &&
              feeProperties[meta.fee_rules[0].prop]) ||
              ""} & ${(meta.fee_rules && rule[meta.fee_rules[0].condition]) ||
              ""} ${
              meta.fee_rules && meta.fee_rules[0]
                ? meta.fee_rules[0].value
                : meta.fee_rules
                ? "0"
                : ""
            }`,
          };
        }
      );

      return { pageInfo: state.fees.page_info, fees };
    }

    return {
      loading: true,
      fees: [],
    };
  },
  getDirectDebitRulesGlobal: (state) => {
    const limitType = {
      transaction_volume: "Transaction Volume",
      transaction_value: "Transaction Value",
      transaction_attempts: "Transaction Attempt",
    };

    const volumeType = {
      transaction_volume: "Volume",
      transaction_value: "Value",
      transaction_attempts: "Attempt",
    };

    if (!state.directDebitRules.loading) {
      const res = {
        rules: state.directDebitRules.rules
          ? state.directDebitRules.rules.map((rule) => ({
              id: rule.id,
              "LIMIT TYPE": limitType[rule.config_type],
              "VALUE / VOLUME": `${rule.value} - ${
                volumeType[rule.config_type]
              }`,
              RESOURCE: capitalizeFirstLetter(rule["category.category_name"]),
              PERIOD: capitalizeFirstLetter(rule.frequency),
              CREATED: moment(rule.createdAt).format("DD-MM-YYYY hh:mm:ssa"),
              "": "",
            }))
          : [],
      };
      return res;
    } else {
      return {
        loading: true,
        rules: [],
      };
    }
  },

  getDirectDebitRulesMerchant: (state) => {
    const limitType = {
      transaction_volume: "Transaction Volume",
      transaction_value: "Transaction Value",
      transaction_attempts: "Transaction Attempt",
    };

    const volumeType = {
      transaction_volume: "Volume",
      transaction_value: "Value",
      transaction_attempts: "Attempt",
    };

    if (!state.directDebitRules.loading) {
      const res = {
        rules: state.directDebitRules.rules
          ? state.directDebitRules.rules.map((rule) => ({
              id: rule.id,
              "LIMIT TYPE": limitType[rule.config_type],
              "VALUE / VOLUME": `${rule.value} - ${
                volumeType[rule.config_type]
              }`,
              RESOURCE: capitalizeFirstLetter(rule["category.category_name"]),
              PERIOD: capitalizeFirstLetter(rule.frequency),
              CREATED: moment(rule.createdAt).format("DD-MM-YYYY hh:mm:ssa"),
              "": "",
            }))
          : [],
      };
      return res;
    } else {
      return {
        loading: true,
        rules: [],
      };
    }
  },

  getSettlementTranches: (state) => {
    if (!state.settlementTranches.loading) {
      const { settlement_batches, page_info } = state.settlementTranches;

      return {
        loading: false,
        page_info,
        tranches: settlement_batches.map(
          ({
            settlement_status,
            settlement_reference,
            amount,
            created_at,
            collection_nuban,
            merchant_name,
            collection_bank_code,
            collection_bank_short_name,
            settlement_nuban,
            settlement_bank_code,
            settlement_bank_short_name,
          }) => ({
            id: settlement_reference,
            ...(!["pending", "settled"].includes(
              settlement_status
                ? settlement_status.toString().toLowerCase()
                : ""
            )
              ? {
                  checkbox: Checkbox,
                }
              : { nocheckbox: true }),

            STATUS: settlement_status,
            reference: settlement_reference,
            "INITIATION DATE": `${moment(created_at).format(
              "hh:mm a"
            )} - ${moment(created_at).format("ll")}`,
            "SOURCE ACCOUNT":
              collection_bank_short_name.toUpperCase() +
              " - " +
              collection_nuban,
            "DESTINATION ACCOUNT":
              settlement_bank_short_name.toUpperCase() +
              " - " +
              settlement_nuban,
            MERCHANT: merchant_name,
            AMOUNT: `₦ ${formatAmount(amount)}`,
          })
        ),
      };
    } else {
      return {
        loading: true,
        tranches: [],
        page_info: {},
      };
    }
  },

  getSettlementRetries: (state) => {
    if (!state.settlementRetries.loading) {
      const { settlement_retries, page_info } = state.settlementRetries;

      return {
        loading: false,
        page_info,
        retries: settlement_retries.map(
          ({
            settlement_retry_status,
            settlement_retry_reference,
            createdAt,
            amount_payable,
            user_message,
          }) => ({
            id: settlement_retry_reference,
            // checkbox: Checkbox,
            STATUS: settlement_retry_status,
            reference: settlement_retry_reference,
            "INITIATION DATE": `${moment(createdAt).format(
              "hh:mm a"
            )} - ${moment(createdAt).format("ll")}`,
            AMOUNT: `₦ ${formatAmount(amount_payable)}`,
            REASON: user_message,
          })
        ),
      };
    } else {
      return {
        loading: true,
        retries: [],
        page_info: {},
      };
    }
  },
  getSubTitle: (state) => {
    return state.subTitle;
  },
  getCustomMetaOptions(state) {
    return state.customMetaOptions;
  },
  getTransactionTypes(state) {
    return state.transactionTypes.map((data) => ({
      id: data.transaction_type,
      value: startCase(data.transaction_type),
    }));
  },

  getPriorityConfigurationList(state) {
    return state.priorityConfigList;
  },
  getActiveLien(state) {
    return state.activeLien;
  },
};
